module.exports = __webpack_public_path__ + "img/op_info.2af1439.png";